import {
  VENDOR_MOBILE_NO,
  VENDOR_MOBILE_NO_SUCCESSFUL,
  GENERATE_OTP,
  GENERATE_OTP_SUCCESSFUL,
  CHECK_OTP,
  CHECK_OTP_SUCCESSFUL,
  Q_DOC_REPORT,
  Q_DOC_REPORT_SUCCESS,
  Q_DOC_PDF,
  API_ERROR,
} from "./actionTypes";

export const getVendorMobile = (token) => {
  return {
    type: VENDOR_MOBILE_NO,
    payload: { token },
  };
};

export const VendorMobileSuccessful = (response) => {
  return {
    type: VENDOR_MOBILE_NO_SUCCESSFUL,
    payload: response,
  };
};
export const generateOTP = (token) => {
  return {
    type: GENERATE_OTP,
    payload: { token },
  };
};

export const generateOTPSuccessful = (response) => {
  return {
    type: GENERATE_OTP_SUCCESSFUL,
    payload: response,
  };
};
export const CheckOTP = (data, history) => {
  return {
    type: CHECK_OTP,
    payload: { data, history },
  };
};
export const CheckOTPSuccessful = (response) => {
  return {
    type: CHECK_OTP_SUCCESSFUL,
    payload: response,
  };
};
// export const getVendorQuotationData = (token) => {
//   return {
//     type: GENERATE_OTP,
//     payload: { token },
//   };
// };

// Vendor Quotation Report
export const getVendQDocReport = (QToken) => {
  return {
    type: Q_DOC_REPORT,
    payload: { QToken },
  };
};
export const QDocReportSuccessful = (response) => {
  return {
    type: Q_DOC_REPORT_SUCCESS,
    payload: response,
  };
};
export const QuotationPdf = (QuotationPdf) => {
  return {
    type: Q_DOC_PDF,
    payload: { QuotationPdf },
  };
};

export const apiError = (error) => {
  return {
    type: API_ERROR,
    payload: error,
  };
};
